// 获取步骤信息列表
export const stepsInfo = state => state.stepsInfo

// 获取提交信息
export const submitInfo = state => state.submitInfo

// 获取当前活动步骤
export const active = state => state.active

// 获取步骤完成情况
export const stepComplete = state => state.stepComplete

// 获取当前步骤
export const currentStep = state => state.submitInfo.step

// 获取商品信息
export const goodsInfo = state => state.submitInfo.goodsInfo

// 获取售卖信息
export const sellInfo = state => state.submitInfo.sellInfo

// 获取发票信息
export const invoiceInfo = state => state.submitInfo.invoiceInfo
